'use client';

import React, { useState } from 'react';
import { useGetWalkerProfileReviewsV6 } from '../../../../hooks/api/useGetWalkerProfileReviews';
import { WalkerReviews } from '../../../../types/api';
import { WalkerServiceReviews } from './WalkerServiceReviews';
type Props = {
  reviews: WalkerReviews;
  averageRating: number;
  identifier: string;
};
export const WalkerReviewsContext = ({
  reviews: initialReviews,
  averageRating,
  identifier
}: Props) => {
  const [reviews, setReviews] = useState<WalkerReviews>(initialReviews);
  const {
    isLoading: isFetchingReviews,
    error: reviewsError,
    getReviews
  } = useGetWalkerProfileReviewsV6(identifier);
  const [isReviewsClamped, setIsReviewsClamped] = useState(false);
  const handleReviewsClampButtonClick = async () => {
    if (reviews?.page !== reviews?.lastPage) {
      const nextPage = reviews.page + 1;
      const result: WalkerReviews = await getReviews({
        page: nextPage,
        reviewType: 'service',
        perPage: 10
      });
      if (!result?.items) {
        // Since this will not throw an error, this will allow
        // us to gracefully handle that error and show the WalkerReviewsError component
        return;
      }
      const {
        items,
        ...rest
      } = result;
      setReviews(prevReviews => ({
        items: [...prevReviews.items, ...items],
        ...rest
      }));
    } else {
      setIsReviewsClamped(!isReviewsClamped);
    }
  };
  return <WalkerServiceReviews reviews={reviews?.items || []} onClampButtonClick={handleReviewsClampButtonClick} error={reviewsError} isReviewsClamped={isReviewsClamped} isFetchingData={isFetchingReviews} hasMoreData={reviews?.page !== reviews?.lastPage} totalReviews={reviews?.total} averageRating={averageRating} data-sentry-element="WalkerServiceReviews" data-sentry-component="WalkerReviewsContext" data-sentry-source-file="index.tsx" />;
};